module.exports = __webpack_public_path__ + "static/image-targets-for-homepage-f022acffda615b676685a9a8e5f6b1a2.mp4";